import { render, staticRenderFns } from "./AddStMrpaTrustee.vue?vue&type=template&id=0588cbde&"
import script from "./AddStMrpaTrustee.vue?vue&type=script&lang=js&"
export * from "./AddStMrpaTrustee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports